module.exports = __webpack_public_path__ + "img/stickers-attestation-CAF.67ad463d.jpg";